import API from '../../apis';
import { action, generateErrorAction } from '../actions';
import actionTypes from './actionTypes';

export const fetchUsers = query => {
  const request = () => {
    return dispatch => {
      dispatch(loading());
      return API.users
        .fetchAllUsers(query)
        .then(res => dispatch(success(res)))
        .catch(err => {
          dispatch(
            generateErrorAction(err, {
              failure: actionTypes.FETCH_USERS_FAILED,
              reject: actionTypes.FETCH_USERS_REJECT
            })
          );
          // throw err;
        });
    };
  };
  const loading = () => action(actionTypes.USER_LOADING);
  const success = res => action(actionTypes.FETCH_USERS_SUCCESSY, res);
  return request();
};

export const updateUser = userObject => {
  const request = () => {
    return dispatch => {
      dispatch(loading());
      return API.users
        .updateUser(userObject)
        .then(res => dispatch(success(res)))
        .catch(err => {
          dispatch(
            generateErrorAction(err, {
              failure: actionTypes.UPDATE_USER_FAILED,
              reject: actionTypes.UPDATE_USER_REJECT
            })
          );
          // throw err;
        });
    };
  };
  const loading = () => action(actionTypes.UPDATE_USER_LOADING);
  const success = res => action(actionTypes.UPDATE_USER_SUCCESS, res);
  return request();
};

export const fetchUserById = id => {
  const request = () => {
    return dispatch => {
      dispatch(loading());
      return API.users
        .fetchUser(id)
        .then(res => dispatch(success(res)))
        .catch(err => {
          dispatch(
            generateErrorAction(err, {
              failure: actionTypes.FETCH_USER_BY_ID_FAILED,
              reject: actionTypes.FETCH_USER_BY_ID_REJECT
            })
          );
          throw err;
        });
    };
  };
  const loading = () => action(actionTypes.USER_BY_ID_LOADING);
  const success = res => action(actionTypes.FETCH_USER_BY_ID_SUCCESSY, res);
  return request();
};

export const getAllUserInfo = (id, query) => {
  if (!query) query = `filter=(userId~eq~${id})`;
  const request = () => {
    return dispatch => {
      dispatch(loading());
      return Promise.all([
        API.users.fetchUser(id),
        API.financialTransactions.fetchAllFinancialTransactions(query),
        API.reservations.fetchAllUserReservationsById(id, query),
        API.tickets.fetchAllUserTicketsById(id, query),
        API.invoices.fetchAllUserInvoicesById(id, query)
      ])
        .then(res => dispatch(success(res)))
        .catch(err => {
          dispatch(
            generateErrorAction(err, {
              failure: actionTypes.FETCH_ALL_USER_DETAILS_FAILED,
              reject: actionTypes.FETCH_ALL_USER_DETAILS_REJECT
            })
          );
          throw err;
        });
    };
  };
  const loading = () => action(actionTypes.FETCH_ALL_USER_DETAILS_LOADING);
  const success = res => action(actionTypes.FETCH_ALL_USER_DETAILS_SUCCESS, res);
  return request();
};

export const createNewUser = userObject => {
  const request = () => {
    return dispatch => {
      dispatch(loading());
      return API.users
        .createNewUser(userObject)
        .then(res => dispatch(success(res)))
        .catch(err => {
          dispatch(
            generateErrorAction(err, {
              failure: actionTypes.CREATE_NEW_USER_FAILED,
              reject: actionTypes.CREATE_NEW_USER_REJECT
            })
          );
          throw err;
        });
    };
  };
  const loading = () => action(actionTypes.CREATE_NEW_USER_LOADING);
  const success = res => action(actionTypes.CREATE_NEW_USER_SUCCESS, res);
  return request();
};
